import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class FreeTextEventMappingKeywordLookup extends ModelBase {
    
    public rawGenericServiceProviderEventKeywordId: number = 0;

    public rawGenericServiceProviderEventMappingId: number = 0;

    public keyword: string = "";
}